export const inboundBufferStorageUnitsToJSON = (
	payload: IInboundBufferStoreStorageUnitsFormPayload,
): IInboundBufferStoreStorageUnitsPayload => ({
	storage_units: payload.storageUnits.map(({ supplierLotNumber, expiryDate, finalUnitPrice, ...rest }) => ({
		...rest,
		supplier_lot_number: supplierLotNumber,
		expiry_date: expiryDate ? expiryDate.toISOString() : null,
		final_unit_price: finalUnitPrice,
	})),
})

export const InboundBufferStorageUnit = (json: IInboundBufferStorageUnit): IInboundBufferStorageUnitModel => {
	const { supplier_lot_number, lot_number, expiry_date, final_unit_price, preview_url, label_print_status, ...rest } =
		json

	return {
		...rest,
		supplierLotNumber: supplier_lot_number,
		lotNumber: lot_number,
		expiryDate: expiry_date ? new Date(expiry_date) : null,
		finalUnitPrice: final_unit_price ?? null,
		previewUrl: preview_url,
		labelPrintStatus: label_print_status,
	}
}

export const InboundBufferStorageUnitLabelPrint = (
	json: IInboundBufferStorageUnitLabelPrint,
): IInboundBufferStorageUnitLabelPrintModel => {
	const { label_id, storage_unit_id, events_url, ...rest } = json

	return {
		...rest,
		labelId: label_id,
		storageUnitId: storage_unit_id,
		eventsUrl: events_url,
	}
}

export const InboundBufferItem = (json: IInboundBufferItem): IInboundBufferItemModel => {
	const {
		delivery_receipt_item_id,
		expected_delivery_id,
		facility_id,
		raw_material_id,
		supplier_id,
		supplier_name,
		supplier_product_name,
		internal_name,
		current_inventory_quantity,
		expected_quantity,
		expiry_date,
		delivery_date,
		delivery_day,
		ordered_unit_price,
		created_at,
		storage_units,
		...rest
	} = json

	return {
		...rest,
		deliveryReceiptItemID: delivery_receipt_item_id,
		expectedDeliveryID: expected_delivery_id,
		facilityID: facility_id,
		rawMaterialID: raw_material_id,
		supplierID: supplier_id,
		supplierName: supplier_name,
		supplierProductName: supplier_product_name,
		internalName: internal_name,
		currentInventoryQuantity: current_inventory_quantity,
		expectedQuantity: expected_quantity,
		expiryDate: expiry_date ? new Date(expiry_date) : null,
		deliveryDate: delivery_date ? new Date(delivery_date) : null,
		deliveryDay: delivery_day,
		orderedUnitPrice: ordered_unit_price ?? null,
		createdAt: new Date(created_at),
		storageUnits: (storage_units ?? []).map(InboundBufferStorageUnit),
	}
}

export const InboundBufferFilterOptions = (json?: IInboundBufferFilters): IInboundBufferFilterOptionsModel => ({
	suppliers: (json?.suppliers ?? []).map(({ supplier_id, supplier_name }) => ({
		supplierID: supplier_id,
		supplierName: supplier_name,
	})),
	deliveryDays: json?.delivery_days ?? [],
})
